var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading.body",
          value: _vm.loading,
          expression: "loading",
          modifiers: { body: true }
        }
      ]
    },
    [
      _c(
        "div",
        { staticClass: "c_page-title" },
        [
          _c("div", [_vm._v("已配需发商品列表")]),
          _vm._v(" "),
          _c(
            "el-button",
            {
              staticClass: "icon-fresh",
              attrs: { size: "mini", icon: "el-icon-refresh" },
              on: {
                click: function($event) {
                  return _vm.fetchData(true)
                }
              }
            },
            [_vm._v("刷新")]
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-row",
        { staticClass: "filter" },
        [
          _c(
            "el-col",
            [
              _c(
                "div",
                {
                  staticStyle: {
                    background: "#f3f3f3",
                    height: "30px",
                    "line-height": "30px",
                    padding: "0 25px",
                    display: "flex",
                    "align-items": "center"
                  }
                },
                [
                  _c("div", [_vm._v("查询搜索")]),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      staticStyle: { "margin-left": "auto" },
                      attrs: {
                        type: "text",
                        icon: _vm.filterFold
                          ? "el-icon-arrow-down"
                          : "el-icon-arrow-up"
                      },
                      on: { click: _vm.toggleFilter }
                    },
                    [_vm._v(_vm._s(_vm.filterFold ? "展开筛选" : "收起筛选"))]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c("el-collapse-transition", [
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: !_vm.filterFold,
                        expression: "!filterFold"
                      }
                    ]
                  },
                  [
                    _c(
                      "div",
                      { staticStyle: { padding: "10px 25px" } },
                      [
                        _c(
                          "el-form",
                          {
                            staticClass: "demo-form-inline",
                            attrs: { inline: true, model: _vm.form }
                          },
                          [
                            _c(
                              "el-form-item",
                              { attrs: { label: "" } },
                              [
                                _c("el-input", {
                                  attrs: { placeholder: "商品货号" },
                                  nativeOn: {
                                    keyup: function($event) {
                                      if (
                                        !$event.type.indexOf("key") &&
                                        _vm._k(
                                          $event.keyCode,
                                          "enter",
                                          13,
                                          $event.key,
                                          "Enter"
                                        )
                                      ) {
                                        return null
                                      }
                                      return _vm.search.apply(null, arguments)
                                    }
                                  },
                                  model: {
                                    value: _vm.form.goods_no,
                                    callback: function($$v) {
                                      _vm.$set(_vm.form, "goods_no", $$v)
                                    },
                                    expression: "form.goods_no"
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              [
                                _c("el-input", {
                                  attrs: { placeholder: "sku" },
                                  nativeOn: {
                                    keyup: function($event) {
                                      if (
                                        !$event.type.indexOf("key") &&
                                        _vm._k(
                                          $event.keyCode,
                                          "enter",
                                          13,
                                          $event.key,
                                          "Enter"
                                        )
                                      ) {
                                        return null
                                      }
                                      return _vm.search.apply(null, arguments)
                                    }
                                  },
                                  model: {
                                    value: _vm.form.sku,
                                    callback: function($$v) {
                                      _vm.$set(_vm.form, "sku", $$v)
                                    },
                                    expression: "form.sku"
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              { attrs: { label: "" } },
                              [
                                _c("el-input", {
                                  attrs: { placeholder: "订单号" },
                                  nativeOn: {
                                    keyup: function($event) {
                                      if (
                                        !$event.type.indexOf("key") &&
                                        _vm._k(
                                          $event.keyCode,
                                          "enter",
                                          13,
                                          $event.key,
                                          "Enter"
                                        )
                                      ) {
                                        return null
                                      }
                                      return _vm.search.apply(null, arguments)
                                    }
                                  },
                                  model: {
                                    value: _vm.form.order_sn,
                                    callback: function($$v) {
                                      _vm.$set(_vm.form, "order_sn", $$v)
                                    },
                                    expression: "form.order_sn"
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-select",
                              {
                                attrs: { filterable: "", placeholder: "仓库" },
                                model: {
                                  value: _vm.form.origin,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "origin", $$v)
                                  },
                                  expression: "form.origin"
                                }
                              },
                              _vm._l(_vm.storehouseIds, function(item) {
                                return _c("el-option", {
                                  key: item.key,
                                  attrs: { label: item.label, value: item.key }
                                })
                              }),
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              { attrs: { label: "下单时间：" } },
                              [
                                _c("el-date-picker", {
                                  attrs: {
                                    type: "datetimerange",
                                    "value-format": "yyyy-MM-dd HH:mm:ss",
                                    "range-separator": "至",
                                    "start-placeholder": "开始日期",
                                    "end-placeholder": "结束日期",
                                    "default-time": ["06:00:00", "06:00:00"]
                                  },
                                  model: {
                                    value: _vm.form.create_time,
                                    callback: function($$v) {
                                      _vm.$set(_vm.form, "create_time", $$v)
                                    },
                                    expression: "form.create_time"
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              [
                                _c(
                                  "el-button",
                                  {
                                    attrs: { type: "primary" },
                                    on: { click: _vm.search }
                                  },
                                  [_vm._v("查询")]
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ]
                )
              ])
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-row",
        [
          _c("el-col", { staticStyle: { border: "1px solid #ddd" } }, [
            _c(
              "div",
              {
                staticStyle: {
                  background: "#f3f3f3",
                  height: "50px",
                  "line-height": "30px",
                  padding: "0 25px",
                  display: "flex",
                  "align-items": "center"
                }
              },
              [
                _c(
                  "el-button",
                  {
                    staticStyle: {
                      "margin-left": "auto",
                      background: "#85ce61"
                    },
                    attrs: { type: "success", size: "mini" },
                    on: { click: _vm.output }
                  },
                  [_vm._v("导出")]
                )
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticStyle: { "margin-bottom": "0" } },
              [
                _vm.resData
                  ? _c(
                      "el-table",
                      {
                        directives: [
                          {
                            name: "loading",
                            rawName: "v-loading",
                            value: _vm.tableLoading,
                            expression: "tableLoading"
                          }
                        ],
                        ref: "multipleTable",
                        staticStyle: { width: "100%" },
                        attrs: {
                          height: "800",
                          data: _vm.resData.list,
                          "tooltip-effect": "dark",
                          "cell-class-name": _vm.addColor
                        },
                        on: { "selection-change": _vm.handleSelectionChange }
                      },
                      [
                        _c("el-table-column", {
                          attrs: {
                            prop: "img",
                            label: "商品图片",
                            "show-overflow-tooltip": "",
                            align: "center"
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function(scope) {
                                  return [
                                    _c(
                                      "div",
                                      {
                                        directives: [
                                          {
                                            name: "viewer",
                                            rawName: "v-viewer"
                                          }
                                        ],
                                        staticStyle: {
                                          width: "40px",
                                          height: "40px",
                                          overflow: "hidden",
                                          cursor: "pointer",
                                          margin: "auto"
                                        }
                                      },
                                      [
                                        _c("img", {
                                          staticStyle: {
                                            width: "100%",
                                            height: "100%"
                                          },
                                          attrs: { src: scope.row.img, alt: "" }
                                        })
                                      ]
                                    )
                                  ]
                                }
                              }
                            ],
                            null,
                            false,
                            3812014799
                          )
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            align: "center",
                            prop: "goods_name",
                            label: "商品名称"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            align: "center",
                            prop: "goods_no",
                            label: "商品货号"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            align: "center",
                            prop: "co_val",
                            label: "颜色"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            align: "center",
                            prop: "si_val",
                            label: "尺码"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: { align: "center", prop: "sku", label: "sku" }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            align: "center",
                            prop: "buy_num",
                            label: "下单数量"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            align: "center",
                            prop: "allot_num",
                            label: "配货数量"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            align: "center",
                            prop: "shipped_num",
                            label: "已发数量"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            align: "center",
                            prop: "order_sn",
                            label: "订单号"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            align: "center",
                            prop: "create_time",
                            label: "下单时间"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            align: "center",
                            prop: "order_infos_origin",
                            label: "仓库"
                          }
                        })
                      ],
                      1
                    )
                  : _vm._e()
              ],
              1
            ),
            _vm._v(" "),
            _vm.resData
              ? _c(
                  "div",
                  { staticStyle: { "text-align": "right", padding: "25px" } },
                  [
                    _c("el-pagination", {
                      attrs: {
                        "current-page": _vm.curPage,
                        background: "",
                        layout: "total, prev, pager, next, jumper ",
                        total: _vm.resData.count,
                        "page-size": 10
                      },
                      on: {
                        "update:currentPage": function($event) {
                          _vm.curPage = $event
                        },
                        "update:current-page": function($event) {
                          _vm.curPage = $event
                        },
                        "current-change": _vm.handleCurrentChange
                      }
                    })
                  ],
                  1
                )
              : _vm._e()
          ])
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2041f5c8", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2041f5c8","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/orderinfos/NeedShipping.vue
// module id = null
// module chunks = 